import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-8 font-bold font-size-24" }
const _hoisted_2 = { class: "flex items-center mb-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-2xl" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_BaseIcon = _resolveComponent("BaseIcon")
  const _component_Table = _resolveComponent("Table")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.t('vacationMaster')), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        class: "w-30 h-10 font-size-16 p-4",
        onClick: _ctx.registerYearPaidHoliday
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.t('signUp')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_Table, {
      class: "text-center",
      headers: _ctx.yearPaidHolidayHeaders,
      data: _ctx.yearPaidHolidayData
    }, {
      edit: _withCtx(({ item }) => [
        _withDirectives(_createVNode("div", {
          class: "text-center",
          onClick: ($event: any) => (_ctx.updateYearPaidHoliday(item))
        }, [
          _createVNode(_component_BaseIcon, {
            name: "pencil-line",
            class: "cursor-pointer"
          })
        ], 8, ["onClick"]), [
          [_directive_tooltip, _ctx.t('actionEdit')]
        ])
      ]),
      delete: _withCtx(({ item }) => [
        _withDirectives(_createVNode("div", {
          class: "text-center",
          onClick: ($event: any) => (_ctx.deleteYearPaidHoliday(item))
        }, [
          _createVNode(_component_BaseIcon, {
            name: "trash",
            class: "cursor-pointer"
          })
        ], 8, ["onClick"]), [
          [_directive_tooltip, _ctx.t('actionDelete')]
        ])
      ]),
      _: 1
    }, 8, ["headers", "data"])
  ]))
}